export default __webpack_public_path__ + "static/media/Helvetica.ad8897e8.ttf";